<app-manual-login *ngIf="english"></app-manual-login>
<app-manual-login-hindi *ngIf="hindi"></app-manual-login-hindi>